//Angular
import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
//App
import { AppAnimations } from 'src/app/_shared/animations';
import { PermissionManagerService } from 'src/app/_shared/services/permission/permissions.service';

@Component({
  animations: [AppAnimations],
  selector: 'advance-settings',
  templateUrl: './layout.component.html'
})
export class LayoutAdvancedSettingsComponent  {
  tabs = [
    {
      label: 'Invoicing Operations',
      route: 'billing-operations',
    },
    {
      label: 'Payment Operations',
      route: 'payment-operations',
    },
    {
      label: 'Notifications',
      route: 'notifications',
    },
    {
      label: 'Dunning Management',
      route: 'dunning-management',
    },
    {
      label: 'Event Logs',
      route: 'events',
    },
    {
      label: 'API Accounts',
      route: 'api-credentials'
    }
  ];
  constructor(
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
    private permissionManagerService: PermissionManagerService
  ) {
    this._iconRegistry.addSvgIcon('ico-actions', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-actions-01.svg'));
    this.manageRestrictions();
  }

  

  manageRestrictions(){
    this.permissionManagerService.isRestricted(
      "publicapi_account|enabled|SCOPE_NOPAGE",
      (res) => {
        if(res){
          this.tabs = this.tabs.filter((tab) => tab.route != "api-credentials");
        }
      }
    );

    this.permissionManagerService.isRestricted(
      "feature_dunning|enabled|SCOPE_NOPAGE",
      (res) => {
        if(res){
          this.tabs = this.tabs.filter((tab) => tab.route != "dunning-management");
        }
      }
    );
  }
}
